const { makeStyles } = require('@material-ui/core');

const useStyles = makeStyles(() => ({
  unitContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 16,
    marginRight: 16,
  },
  hospName: {
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#003366',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 70,
  },
  hospActions: {
    fontFamily: 'Poppins',
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#6B6560',
  },
  nameContainer: { width: '100%', marginLeft: 30 },
  compactRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    marginBottom: 8,
    padding: '4px 0',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  compactPin: {
    fontSize: 22,
  },
  compactIconBtn: {
    padding: 4,
  },
}));

export default useStyles;
